/* eslint-disable */
import { ReactComponent as MilestoneTodoIcon } from 'assets/svgs/zapier-logo.svg';
import React from 'react';
import { CardLink } from 'components/molecules/card-link/card-link';

export const DemoCardLinkPage = () => (
  <>
    <h3>With no hover</h3>
    <CardLink
      link={{ to: '/' }}
      title="Card title"
      description="card description"
      icon={<MilestoneTodoIcon />}
    />

    <h3>With hover</h3>
    <CardLink
      link={{ to: '/' }}
      title="Card title"
      description="card description"
      hoverable
      icon={<MilestoneTodoIcon />}
    />
  </>
);
